import PropTypes from "prop-types";
import React from "react";

import Edit from "../../components/Edit";
import Preview from "../../components/Preview";
import Tab from "../../components/Tab";
import Tabs from "../../components/Tabs";

import { DEFAULT_EDIT_TAB_TEXT, DEFAULT_PREVIEW_TAB_TEXT, DEFAULT_TABS_WRAPPER_STYLES } from "../../constants.js";

var LayoutTabs = function LayoutTabs(_ref) {
  var enhancedComponent = _ref.enhancedComponent,
      displayName = _ref.displayName,
      onChange = _ref.onChange,
      hiddenProps = _ref.hiddenProps,
      tabsColor = _ref.tabsColor;

  return React.createElement(
    "div",
    null,
    React.createElement(
      "div",
      { style: DEFAULT_TABS_WRAPPER_STYLES },
      React.createElement(
        Tabs,
        { color: tabsColor },
        React.createElement(
          Tab,
          { label: DEFAULT_PREVIEW_TAB_TEXT },
          React.createElement(Preview, {
            displayName: displayName,
            hiddenProps: hiddenProps,
            enhancedComponent: enhancedComponent
          })
        ),
        React.createElement(
          Tab,
          { label: DEFAULT_EDIT_TAB_TEXT },
          React.createElement(Edit, {
            displayName: displayName,
            hiddenProps: hiddenProps,
            enhancedComponent: enhancedComponent,
            onChange: onChange
          })
        )
      )
    ),
    enhancedComponent
  );
};

LayoutTabs.propTypes = process.env.NODE_ENV !== "production" ? {
  enhancedComponent: PropTypes.element.isRequired,
  displayName: PropTypes.string,
  hiddenProps: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  tabsColor: PropTypes.string
} : {};

export default LayoutTabs;